import { TProfile } from 'src/types/profiles/profile.model';
import { FunctionEnum, PageRouteEnum } from '../enums/permissionType';

/**
 * Check user function of page
 * @param page
 * @param func
 * @param userPermissions
 * @returns
 */
function isPermissionFuntion(page: PageRouteEnum, func: FunctionEnum, profile: TProfile) {
  if (profile.isAdmin) return true;

  if (!profile.userPermissions || !func) return false;

  const pagePermission = profile.userPermissions.filter(x => x.pageId == +page);
  const isPermission = pagePermission.some(
    x => x.functionIds.includes(+func) || x.functionIds.includes(+FunctionEnum.FULL)
  );

  return isPermission;
}

export { isPermissionFuntion };
